@if (parentFormGroup &&
  parentFormGroup.controls &&
  parentFormGroup.controls[this.controlName]) {
  <div
    >
    <mat-form-field
      [formGroup]="parentFormGroup"
      hideRequiredMarker
      appearance="fill"
      class="form-field text-area w-full"
      floatLabel="always"
      >
      <mat-label class="text-type-13">{{ label }}:</mat-label>
      <input
        type="text"
        [placeholder]="placeholder"
        aria-label="Number"
        matInput
        [formControlName]="controlName"
        [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-form-field>
  </div>
}
